<template>
    <div>
        <a
            href="#"
            @click.prevent="openModal"
            class="rate-plan-link"
        >
            {{ ratePlanName }}
                <!-- Additional Template -->
            <span class="rate-plan-extra">
                <slot name="after-name"></slot>
            </span>
        </a>
        
        <!-- Modal -->
        <section v-if="show">
            <RatePlanModule ref="rate-plan-current" @closed="show=false" :unableEdit="true"></RatePlanModule>
        </section>
    </div>
</template>

<script>
import RatePlanModule from "@/components/sections/rate-plans/Single"
export default {
    props: {
        ratePlanId: {
            type: [String, Number],
            required: true,
        },
        ratePlanName: {
            type: String,
            required: true,
        },
        modalProps: {
            type: Object,
            default: () => ({}), // Pass additional props to the modal content
        },
    },
    components: {RatePlanModule},
    data(){
        return {
            show:false
        }
    },
  
    methods: {
        openModal() {
            this.show = true;
            setTimeout(() => {
                this.$refs["rate-plan-current"].loadModel(this.ratePlanId)
            }, 100);
            //this.$bvModal.show('rate-plan-modal');
        
        }
    },
};
</script>

  